export default __webpack_public_path__ + "static/media/AnexarComTexto.c4374ff2.svg";